export const ROLES = {
  admin: {
    displayText: "Admin",
    id: 1,
  },
  basicUser: {
    displayText: "Basic User",
    id: 2,
  },
  stLead: {
    displayText: "S&T Lead",
    id: 3,
  },
  gpLead: {
    displayText: "GP Lead",
    id: 4,
  },
};
